import { isAbsoluteUrl } from "./utils";

/*
 * Converts a URL (which can either be an absolute URL or a relative URL)
 * to a relative URL with a leading "/" guaranteed.
 */
export const normalizeHref = (href: string) => {
  let pathName = href;

  if (isAbsoluteUrl(href)) {
    const url = new URL(href);

    pathName = url.pathname;
  }

  return pathName[0] !== "/" ? `/${pathName}` : pathName;
};
